var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "word-preview" },
    [
      _c("NotPreviewContentComponent", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.isPreviewOpened &&
              _vm.renderTypeOfComponent() === _vm.componentType.NotContent,
            expression:
              "isPreviewOpened && renderTypeOfComponent() === componentType.NotContent",
          },
        ],
        ref: "NotPreviewContentComponentRef",
        on: {
          failPreview: _vm.onPreviewFail,
          "close-viewer-event": _vm.toggle,
        },
      }),
      _c("WordPreviewComponent", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.isPreviewOpened &&
              _vm.renderTypeOfComponent() === _vm.componentType.Word,
            expression:
              "isPreviewOpened && renderTypeOfComponent() === componentType.Word",
          },
        ],
        ref: "WordPreviewComponentRef",
        on: {
          failPreview: _vm.onPreviewFail,
          "close-viewer-event": _vm.toggle,
        },
      }),
      _c("PdfPreviewComponent", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.isPreviewOpened &&
              _vm.renderTypeOfComponent() === _vm.componentType.Pdf,
            expression:
              "isPreviewOpened && renderTypeOfComponent() === componentType.Pdf",
          },
        ],
        ref: "PdfPreviewComponentRef",
        on: {
          failPreview: _vm.onPreviewFail,
          "close-viewer-event": _vm.toggle,
        },
      }),
      _c("ImagePreviewComponent", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.isPreviewOpened &&
              _vm.renderTypeOfComponent() === _vm.componentType.Jpg,
            expression:
              "isPreviewOpened && renderTypeOfComponent() === componentType.Jpg",
          },
        ],
        ref: "ImagePreviewComponentRef",
        on: {
          failPreview: _vm.onPreviewFail,
          "close-viewer-event": _vm.toggle,
        },
      }),
      _c("EmailPreviewComponent", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.isPreviewOpened &&
              _vm.renderTypeOfComponent() === _vm.componentType.Eml,
            expression:
              "isPreviewOpened && renderTypeOfComponent() === componentType.Eml",
          },
        ],
        ref: "EmailPreviewComponentRef",
        on: {
          failPreview: _vm.onPreviewFail,
          "close-viewer-event": _vm.toggle,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }